import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { layoutDisplaysMediaSlot, playgroundBannerSchema } from "@diality/contracts";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
import { Section } from "./_section";
/**
 * PlaygroundBannerBlock — test-only full-width banner (frozen contract:
 * docs/briefs/playground-components.md §1). The sole catalog exerciser of the
 * multi-target framing + layout-honesty mechanism since the Hero went
 * text-only. Rendered identically by the CMS canvas and the public site; only
 * image resolution differs, via BlockRenderProvider.
 *
 * CRITICAL LAYOUT CONSTRAINT: which framing a screen sees is a container query
 * against the `@container w-full` wrapper BlockRenderer adds
 * (block-renderer.tsx:53, FRAMING_VISIBILITY in render/context.tsx). Nothing in
 * this markup may cap the width of the image's container below full width, or
 * the wide/narrow framings will not switch at the 640px container breakpoint.
 * Keep the markup minimal; no interactive elements.
 */
const CONTAINER = "w-full px-4 @min-[640px]:px-6 @min-[1024px]:px-8";
export function PlaygroundBannerBlock({ data }) {
    const { heading, subheading, displaysMedia, media } = data;
    return (_jsx(Section, { children: _jsx("div", { className: CONTAINER, children: _jsxs("div", { className: "flex w-full flex-col gap-6", children: [_jsx("h2", { className: "text-balance text-3xl font-bold tracking-tight @min-[640px]:text-4xl", children: heading }), subheading && (_jsx("p", { className: "text-pretty text-base text-muted-foreground", children: subheading })), displaysMedia && (_jsx(MediaSlotView, { image: media, ratio: "16 / 9", label: "Banner media", emptyRender: null }))] }) }) }));
}
const VARIANTS = ["centered", "split"];
export function playgroundBannerFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    const raw = s.variant;
    return {
        heading: s.heading || "",
        subheading: s.subheading || undefined,
        // Unrecognised/unset coerces to the schema's fallback, the same way the
        // layout schema reads it — the default path is the trap on purpose.
        variant: VARIANTS.includes(raw) ? raw : "centered",
        // The layout rule stated ONCE: the same predicate BlockInspector uses for
        // its warning (imported from @diality/contracts), so what the Editor is
        // told and what the page renders cannot drift apart.
        displaysMedia: layoutDisplaysMediaSlot(playgroundBannerSchema, s, "media"),
        // Resolved even when the layout hides it: the image is kept, never dropped
        // from data — hiding is the component's render decision, not a data loss.
        media: resolveSlotMedia(block, "media", resolve),
    };
}
export const playgroundBannerBlockEntry = {
    Component: PlaygroundBannerBlock,
    fromBlock: playgroundBannerFromBlock,
};
//# sourceMappingURL=playground-banner.js.map